export enum MoveSsrsOptionsEnum {
    OverbookSsr = 0,
    MoveAvailableSsr = 1,
    MoveNone = 2
}
